<div class="chat-bubble" *ngIf="visible">
  <button type="button" class="fab" (click)="toggle()" [attr.aria-expanded]="isOpen" aria-label="Mở chat">
    <span class="icon" aria-hidden="true">💬</span>
    <span class="badge" *ngIf="!isOpen && unread > 0">{{ unread }}</span>
  </button>

  <dialog class="panel" *ngIf="isOpen" open aria-label="Chat hỗ trợ">
    <header class="header">
      <div class="title">
        <div class="t1">Hỗ trợ</div>
        <div class="t2">Online</div>
      </div>
      <button type="button" class="x" (click)="close()" aria-label="Đóng">✕</button>
    </header>

    <div class="msgs" #list>
      <div class="msg system" *ngIf="loading">
        <div class="bubble">Đang tải tin nhắn...</div>
      </div>

      <div
        class="row"
        *ngFor="let m of messages"
        [class.is-me]="m.from==='me'"
        [class.is-them]="m.from==='support'"
        [class.is-system]="m.from==='system'">

        <div class="avatar" *ngIf="m.from==='support'" aria-hidden="true">
          <img *ngIf="m.avatarUrl" [src]="m.avatarUrl" alt="" />
          <span *ngIf="!m.avatarUrl">S</span>
        </div>

        <div class="stack">
          <div
            class="bubble"
            [class.me]="m.from==='me'"
            [class.them]="m.from==='support'"
            [class.system]="m.from==='system'"
            [class.is-image]="!!m.imageUrl">
            <ng-container *ngIf="m.imageUrl; else textOnly">
              <img class="img" [src]="m.imageUrl" alt="" />
            </ng-container>
            <ng-template #textOnly>
              {{ m.text }}
            </ng-template>
          </div>
          <!-- chỉ phân theo ngày bằng divider; không hiển thị giờ/phút từng tin -->
        </div>
      </div>
    </div>

    <form class="input" (ngSubmit)="submit()">
      <button type="button" class="attach" (click)="fileInput.click()" aria-label="Gửi ảnh">＋</button>
      <input #fileInput type="file" accept="image/*" (change)="onPickFile($event)" hidden />

      <input #input type="text" name="draft" [(ngModel)]="draft" placeholder="Nhập tin nhắn..." autocomplete="off" />
      <button type="submit" [attr.aria-disabled]="!draft.trim()">Gửi</button>
    </form>
  </dialog>
</div>
